<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5634 9.2706L4.12787 1.13559C3.5812 0.846302 2.92212 1.24339 2.92212 1.86156C2.92212 3.66929 4.17212 7.90976 4.17212 7.90976C4.17212 7.90976 4.52959 8.78765 5.00326 8.84233L11.7644 9.62247C12.209 9.67375 12.209 10.3194 11.7644 10.3707L5.00326 11.1509C4.52959 11.2055 4.17212 12.0834 4.17212 12.0834C4.17212 12.0834 2.92212 16.415 2.92212 18.2684C2.92212 18.7026 3.27356 19.005 3.70496 18.9554C4.13733 18.9058 3.71025 19.1154 19.5634 10.7226C20.1452 10.4145 20.1455 9.57874 19.5634 9.2706Z"
      fill="white"
      fill-opacity="0.4"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "SendMessage",
})
</script>

<style></style>
